// 左侧plot组件的排序
export default [
  '3D基础柱状图',
  '3D分组柱状图'
]
